module.exports = __webpack_public_path__ + "img/imghanxing.c0f12d90.png";